<template>
    <div class="page view">
        <h1>15) 인당 평균 구매상품수 (월간)</h1>
        <div id="main-content" class="wiki-content">
            <br>
            <p>인당 평균 구매 상품수를 월 단위로 제공합니다.</p>
            <p>전체사용자수, 전체사용자 구매상품수, 전체사용자 인당 평균 구매상품수, 추천클릭사용자수, 추천클릭사용자 구매상품수, 추천클릭사용자 인당 평균 구매상품수를 알 수 있습니다.</p>
            <p>이번 달의 데이터는 어제 날짜 데이터까지의 합산으로 제공합니다.</p>
            <p><span style="color: rgb(0,0,0);line-height: 1.4285715;">GET 방식으로 요청하실 수 있고 정상적으로 요청이 완료되는 경우는 JSON 형태의 추천리스트가 반환됩니다. callback 파라미터를 명시하는 경우 JSONP 형태로 응답합니다.</span></p>
            <p><span style="color: rgb(0,0,0);">요청에 실패할 경우 상황에 따라 4XX 혹은 5XX형태의 에러코드가 반환됩니다.</span></p>
            <h3 id="id-15)인당평균구매상품수(월간)-ResourceURL"><span style="color: rgb(0,0,0);">Resource URL</span></h3>
            <p><span style="color: rgb(0,0,0);"><span> <span class="nolink">https://api.recopick.com/1/admin/:service_id/feed/monthlyordercnt</span></span></span></p>
            <p><a href="https://api.recopick.com/2/recommend/:service_id/:item_id" class="external-link"> </a></p>
            <h3 id="id-15)인당평균구매상품수(월간)-Parameters"><a href="https://api.recopick.com/2/recommend/:service_id/:item_id" class="external-link"><span class="mw-headline">Parameters</span></a></h3>
            <div class="table-wrap">
                <table class="wrapped confluenceTable">
                    <tbody>
                    <tr>
                        <th class="confluenceTh">
                            <p>service_id</p>
                            <p><sup><span style="color: rgb(153,153,153);">(required)</span></sup></p>
                        </th>
                        <td class="confluenceTd">
                            <p><span style="color: rgb(34,34,34);">RecoPick에서 발급된 service id를 의미합니다. service id <span style="color: rgb(34,34,34);">값은 </span><a href="http://admin.recopick.com/-/api_info" class="external-link">어드민 대시보드</a><span style="color: rgb(34,34,34);"> </span><span style="color: rgb(34,34,34);">에서 확인하실 수 있습니다.</span></span></p>
                            <p><code><strong>Example Values :</strong><span style="color: rgb(34,34,34);"> 17</span></code></p>
                        </td>
                    </tr>
                    <tr>
                        <th class="confluenceTh">
                            <p>access_key</p>
                            <p><sup><span style="color: rgb(153,153,153);">(required)</span></sup></p>
                        </th>
                        <td class="confluenceTd">
                            <p><span style="color: rgb(34,34,34);">보안이 적용된 API를 호출하기 위해 사용되는 보안키를 의미합니다. 보안키 값은 <a href="http://admin.recopick.com/-/setting" class="external-link">레코픽 대시보드</a>에서 확인하실 수 있습니다.</span></p>
                            <p><code><strong>Example Values :</strong><span style="color: rgb(34,34,34);"> 1f385dca73fb935cb11f8a246ea85f94</span></code></p>
                        </td>
                    </tr>
                    <tr>
                        <th colspan="1" class="confluenceTh">
                            <p>ago</p>
                            <p><sup><span style="color: rgb(153,153,153);">(optional)</span></sup></p>
                        </th>
                        <td colspan="1" class="confluenceTd">
                            <p><span style="color: rgb(34,34,34);">읽어올 데이터의 항목수를 의미합니다. 기본값은 7입니다.</span></p>
                            <p><code><strong>Example Values :</strong><span style="color: rgb(34,34,34);"> 7</span></code></p>
                        </td>
                    </tr>
                    <tr>
                        <th colspan="1" class="confluenceTh">
                            <p>skip</p>
                            <p><sup><span style="color: rgb(153,153,153);">(optional)</span></sup></p>
                        </th>
                        <td colspan="1" class="confluenceTd">
                            <p><span style="color: rgb(34,34,34);">지정된 값만큼 이전 데이터를 읽어옵니다. 0으로 지정할 경우 어제 데이터까지, 1로 지정할 경우 그저께의 데이터까지 읽어옵니다. 기본값은 0입니다.</span></p>
                            <p><code><strong>Example Values :</strong><span style="color: rgb(34,34,34);"> 12</span></code></p>
                        </td>
                    </tr>
                    <tr>
                        <th colspan="1" class="confluenceTh">
                            <p>offset</p>
                            <p><sup><span style="color: rgb(153,153,153);">(optional)</span></sup></p>
                        </th>
                        <td colspan="1" class="confluenceTd">
                            <p><span style="color: rgb(34,34,34);">시간대(Timezone)의 UTC(협정 세계 표준시)와의 차이를 분 단위로 지정합니다. UTC 대비 9시간 빠른 서울의 경우 -540으로 지정합니다. 기본값은 0입니다.</span></p>
                            <p><code><strong>Example Values :</strong><span style="color: rgb(34,34,34);"> -540</span></code></p>
                        </td>
                    </tr>
                    <tr>
                        <th class="confluenceTh">
                            <p>callback</p>
                            <p><sup><span style="color: rgb(153,153,153);">(optional)</span></sup></p>
                        </th>
                        <td class="confluenceTd">
                            <p><span style="color: rgb(34,34,34);"><span>callback을 입력하시면 JSONP 형태의 응답을 제공합니다.</span></span></p>
                            <p><code><strong>Example Values :</strong><span style="color: rgb(34,34,34);"> callback=parseResponse<br /></span></code></p>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <p><a href="https://api.recopick.com/2/recommend/:service_id/:item_id" class="external-link"><span><br /></span></a></p>
            <h3 id="id-15)인당평균구매상품수(월간)-ExampleRequest"><a href="https://api.recopick.com/2/recommend/:service_id/:item_id" class="external-link"><span>Example Request</span></a></h3>
            <hr />
            <p><a href="https://api.recopick.com/2/recommend/:service_id/:item_id" class="external-link"><span><strong>GET   </strong> </span><span class="nolink">https://api.recopick.com/1/admin/2/feed/monthlyordercnt?access_key=REPLACE_THIS&amp;ago=12&amp;skip=0&amp;offset=-540</span><br /><span> </span></a></p>
            <h3 id="id-15)인당평균구매상품수(월간)-Output">Output</h3>
            <h3 id="id-15)인당평균구매상품수(월간)-반환되는JSON필드설명은아래를참고해주세요."><span style="color: rgb(0,0,0);"> </span><span>반환되는 JSON 필드 설명은 아래를 참고해주세요.</span></h3>
            <div class="code panel pdl conf-macro output-block" style="border-width: 1px;" data-hasbody="true" data-macro-name="code">
                <div class="codeContent panelContent pdl">
            <pre class="syntaxhighlighter-pre" data-syntaxhighlighter-params="brush: js; gutter: false; theme: Eclipse" data-theme="Eclipse">{
  &quot;201804&quot;: {
    &quot;uv&quot;: 48385,
    &quot;total_sum_order&quot;: 8862,
    &quot;total_avg_order&quot;: 0.21,
    &quot;reco_uv&quot;: 10105,
    &quot;reco_sum_order&quot;: 4012,
    &quot;reco_avg_order&quot;: 0.48
  },
  &quot;201805&quot;: {
    &quot;uv&quot;: 56465,
    &quot;total_sum_order&quot;: 22557,
    &quot;total_avg_order&quot;: 0.38,
    &quot;reco_uv&quot;: 18891,
    &quot;reco_sum_order&quot;: 9317,
    &quot;reco_avg_order&quot;: 0.51
  },
  &quot;201806&quot;: {
    &quot;uv&quot;: 58955,
    &quot;total_sum_order&quot;: 17207,
    &quot;total_avg_order&quot;: 0.29,
    &quot;reco_uv&quot;: 7968,
    &quot;reco_sum_order&quot;: 4828,
    &quot;reco_avg_order&quot;: 0.61
  },
  &quot;201807&quot;: {
    &quot;uv&quot;: 34979,
    &quot;total_sum_order&quot;: 17958,
    &quot;total_avg_order&quot;: 0.31,
    &quot;reco_uv&quot;: 13107,
    &quot;reco_sum_order&quot;: 6110,
    &quot;reco_avg_order&quot;: 0.35
  },
  &quot;201808&quot;: {
    &quot;uv&quot;: 74258,
    &quot;total_sum_order&quot;: 49431,
    &quot;total_avg_order&quot;: 0.38,
    &quot;reco_uv&quot;: 22804,
    &quot;reco_sum_order&quot;: 11295,
    &quot;reco_avg_order&quot;: 0.46
  },
  &quot;201809&quot;: {
    &quot;uv&quot;: 80003,
    &quot;total_sum_order&quot;: 47792,
    &quot;total_avg_order&quot;: 0.38,
    &quot;reco_uv&quot;: 22114,
    &quot;reco_sum_order&quot;: 11959,
    &quot;reco_avg_order&quot;: 0.45
  },
  &quot;201810&quot;: {
    &quot;uv&quot;: 56467,
    &quot;total_sum_order&quot;: 22668,
    &quot;total_avg_order&quot;: 0.41,
    &quot;reco_uv&quot;: 17700,
    &quot;reco_sum_order&quot;: 8318,
    &quot;reco_avg_order&quot;: 0.45
  }
}</pre>
                </div>
            </div>
            <p><span><br /></span></p>
            <p><span><br /></span></p>
            <div class="table-wrap">
                <table class="wrapped confluenceTable" style="line-height: 1.4285715;">
                    <tbody>
                    <tr>
                        <th colspan="2" class="confluenceTh">field</th>
                        <th style="text-align: center;" class="confluenceTh"><strong>의 미</strong></th>
                        <th style="text-align: center;" class="confluenceTh"><strong>비 고</strong></th>
                    </tr>
                    <tr>
                        <th class="confluenceTh">YYYYMM</th>
                        <th colspan="1" class="confluenceTh"><br /></th>
                        <td class="confluenceTd">년월</td>
                        <td class="confluenceTd">해당 월의 데이터를 나타냅니다.</td>
                    </tr>
                    <tr>
                        <th colspan="1" class="confluenceTh"><br /></th>
                        <th colspan="1" class="confluenceTh">uv</th>
                        <td colspan="1" class="confluenceTd">전체 방문자수</td>
                        <td colspan="1" class="confluenceTd">해당 월의 전체사용자 수</td>
                    </tr>
                    <tr>
                        <th colspan="1" class="confluenceTh"><br /></th>
                        <th colspan="1" class="confluenceTh">total_sum_order</th>
                        <td colspan="1" class="confluenceTd">전체 주문건수</td>
                        <td colspan="1" class="confluenceTd">해당 월의 전체사용자 구매상품 수</td>
                    </tr>
                    <tr>
                        <th colspan="1" class="confluenceTh"><br /></th>
                        <th colspan="1" class="confluenceTh">total_avg_order</th>
                        <td colspan="1" class="confluenceTd">전체 인당 주문건수</td>
                        <td colspan="1" class="confluenceTd">해당 월의 전체사용자 인당 평균 구매상품 수</td>
                    </tr>
                    <tr>
                        <th class="confluenceTh"><br /></th>
                        <th class="confluenceTh">reco_uv</th>
                        <td class="confluenceTd">추천 방문자수</td>
                        <td class="confluenceTd"><span>해당 월의 추천클릭사용자 수</span></td>
                    </tr>
                    <tr>
                        <th class="confluenceTh"><br /></th>
                        <th class="confluenceTh">reco_sum_order</th>
                        <td class="confluenceTd">추천 주문건수</td>
                        <td class="confluenceTd">해당 월의 추천클릭사용자 구매상품 수</td>
                    </tr>
                    <tr>
                        <th class="confluenceTh"><br /></th>
                        <th class="confluenceTh">reco_avg_order</th>
                        <td class="confluenceTd">추천 인당 추천 주문건수</td>
                        <td class="confluenceTd">해당 월의 추천클릭사용자 인당 평균 구매상품 수</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>